import { motion } from "framer-motion";
import { Calendar, Clock, MapPin } from "lucide-react";

const details = [
    {
        icon: Calendar,
        label: "Date",
        value: "Saturday, 18 July",
        accent: "bg-[#0D9488] text-white",
    },
    {
        icon: Clock,
        label: "Time",
        value: "1:00 PM – 9:00 PM",
        accent: "bg-[#FACC15] text-slate-900",
    },

];

export default function EventDetails() {
    return (
        <section
            id="details"
            data-testid="event-details"
            className="relative bg-white py-20 sm:py-28 border-y border-slate-100"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                    className="max-w-3xl mb-12"
                >
                    <p className="text-sm font-semibold tracking-[0.2em] uppercase text-[#0D9488] mb-4">
                        The essentials
                    </p>
                    <h2 className="font-montserrat font-black tracking-tighter text-4xl sm:text-5xl md:text-6xl leading-[0.95] text-slate-900">
                        <span className="ais-gradient">Where &amp; when.</span>
                    </h2>
                </motion.div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-5 max-w-4xl">
                    {details.map((d, idx) => {
                        const Icon = d.icon;
                        return (
                            <motion.div
                                key={d.label}
                                initial={{ opacity: 0, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, amount: 0.3 }}
                                transition={{
                                    duration: 0.5,
                                    delay: idx * 0.1,
                                }}
                                className="relative rounded-3xl bg-[#FAF9F6] border border-slate-100 p-7 hover:border-[#0D9488]/40 transition-colors"
                                data-testid={`detail-${d.label.toLowerCase()}`}
                            >
                                <div
                                    className={`inline-flex items-center justify-center w-12 h-12 rounded-xl mb-5 ${d.accent}`}
                                >
                                    <Icon className="w-5 h-5" />
                                </div>
                                <p className="text-xs font-semibold uppercase tracking-wider text-slate-500 mb-2">
                                    {d.label}
                                </p>
                                <p className="font-display font-bold text-2xl sm:text-3xl text-slate-900 leading-tight">
                                    {d.value}
                                </p>
                                {d.sub && (
                                    <p className="mt-2 text-slate-600 text-sm">
                                        {d.sub}
                                    </p>
                                )}
                            </motion.div>
                        );
                    })}
                </div>


            </div>
        </section>
    );
}
